// Placeholder UI (to be replaced with the real recipe card grid)
import { RecipeSummaryCard } from 'services/recipes/types';

import styles from './RecipeList.module.scss';

const RecipeList = ({ recipes }: { recipes: RecipeSummaryCard[] }) => (
  <ul className={styles.grid}>
    {recipes.map(recipe => (
      <li key={recipe.id} className={styles.card}>
        {recipe.id}
      </li>
    ))}
  </ul>
);

export default RecipeList;
